import $ from 'jquery';
import './sdaListSelector';
// Core select list widget.  This widget has two methods, open and close and implements sdaListSelector to
// manage selected states.

$.valHooks.sdaSelectList = {
    get(el) {
        return $(el).data().val;
    },
    set(el, val) {
        const $el = $(el);

        $el.find('.sda-list-selector').val(val);
        $el.data({val});

        return $el;
    },
};

$.fn.sdaSelectList = function(data) {
    const $content = $(this.html()).clone();
    let $ul;

    if (this.is('[data-compiled]')) {
        $ul = this.find('ul');
        $ul.sdaListSelector();

        return this;
    }

    this[0].type = 'sdaSelectList';

    data = data || {};
    $.extend(data, this.data());

    this.html('<ul data-sda-widget="list-selector"></ul>')
        .addClass('list-wrapper')
        .unbind('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd')
        .bind('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', () => {
            this.hasClass('list-open') ? this.addClass('overflow-auto') : false;
        });

    $ul = this.find('ul');

    $ul.html($content).sdaListSelector();

    // listeners
    this.off('.sdaSelectList toggle.open')
        .on('open.sdaSelectList', e => {
            e.stopPropagation();
            this.addClass('list-open');
        })
        .on('close.sdaSelectList', e => {
            e.stopPropagation();
            this.removeClass('list-open overflow-auto');
        })
        .on('toggle.open', () => {
            this.hasClass('list-open') ? this.close() : this.open();
        })
        // methods
        .attachMethod('clearList', () => {
            $ul[0].removeChildren();

            return this;
        })
        .attachMethod('addItem', html => {
            $ul.append(html);

            return this;
        })
        .attr('data-compiled', '')
        .addClass('sda-select-list');

    return this;
};
